import queryString from 'query-string';
import React from 'react';
import * as Space from 'react-spaces';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import Authenticator from './Authenticator';
import PluginToolbar from './Components/AppBar';
import DecisionTreeWindow from './Components/DecisionTreeWindow';
import Header from './Components/Header';
import MainWindow from './Components/MainWindow';
import NotificationSnackbarReminder from './Components/NotificationSnackbarReminder';
import StyledSnackbarProvider from './Components/StyledSnackbarProvider';
import useResizeWindow from './Hooks/useResizeWindow';
import useLiveContext, { LiveContextProvider } from './LiveContext/useLiveContext';
import StyledBox, { renderStyledHandler } from './styles';
import SessionPanel from './Components/SessionPanel';
import QuickAccessBar from './Components/QuickAccessBar';
import BlackListLinkContextProvider from './Contexts/BlackListLinkContextProvider';
import AudioWarning from './Components/AudioWarning';

function InnerLivePage(props: { setRef: React.Dispatch<React.SetStateAction<HTMLDivElement>> }) {
  const { setRef } = props;
  const { sessionState: { session }, decisionTreeState: { isMounted } } = useLiveContext();
  const [notificationPermission, setNotificationPermission] = React.useState<string>('default');
  useResizeWindow(!!session, isMounted);

  React.useEffect(() => {
    Notification.requestPermission()
      .then((permission) => {
        setNotificationPermission(permission);
      });
  }, []);
  return (
    <StyledBox>
      <Space.Top size={48}>
        <Header />
      </Space.Top>
      <Space.Fill>
        <QuickAccessBar />
        <Space.Fill>
          <Space.Fill>
            <Space.Fill>
              <Space.Fill>
                <MainWindow setRef={setRef} />
                <PluginToolbar />
              </Space.Fill>
              {session && (
                <Space.RightResizable size={270} maximumSize={400} minimumSize={40} handleRender={renderStyledHandler}>
                  <SessionPanel key="detection" />
                </Space.RightResizable>
              )}
            </Space.Fill>
            {isMounted && (
              <Space.BottomResizable size="50%" minimumSize={100} handleRender={renderStyledHandler}>
                <DecisionTreeWindow />
              </Space.BottomResizable>
            )}
            <NotificationSnackbarReminder notificationPermission={notificationPermission} />
            <AudioWarning />
          </Space.Fill>
        </Space.Fill>
      </Space.Fill>
    </StyledBox>
  );
}

export default function App() {
  const [ref, setRef] = React.useState<HTMLDivElement | null>(null);
  return (
    <Authenticator>
      <QueryParamProvider
        adapter={ReactRouter6Adapter}
        options={{
          searchStringToObject: queryString.parse,
          objectToSearchString: queryString.stringify,
        }}
      >
        <BlackListLinkContextProvider>
          <StyledSnackbarProvider domRoot={ref}>
            <LiveContextProvider>
              <InnerLivePage setRef={setRef} />
            </LiveContextProvider>
          </StyledSnackbarProvider>
        </BlackListLinkContextProvider>
      </QueryParamProvider>
    </Authenticator>
  );
}
